module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/kinrgy-b3044d5b02ea378c8dc8202b05c95e13.png";